import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMergedRef, useStateStrict } from "@ajayvikas/react-common";
import React from "react";
import { Clear } from "../icons/Clear";
import cls from "./combo-box.module.scss";
import classNames from "classnames";
import { useAutoAnimate } from "@formkit/auto-animate/react";
export const Tags = (props) => {
    const { textValues: selectedTextValue, showClear, values, style, className, placeHolder } = props;
    const [collapse, setCollapse] = useStateStrict(false);
    const [animRef] = useAutoAnimate();
    const tagRef = React.useRef(null);
    const mergeRef = useMergedRef(tagRef, animRef);
    const dummyRef = React.useRef(null);
    React.useLayoutEffect(() => {
        if (!tagRef.current || !dummyRef.current)
            return;
        dummyRef.current.style.display = "";
        const actualWidth = dummyRef.current.scrollWidth;
        dummyRef.current.style.display = "none";
        setCollapse(tagRef.current.offsetWidth < actualWidth);
    }, [setCollapse, values]);
    const onValueClear = (e, value) => {
        if (e.defaultPrevented)
            return;
        e.preventDefault();
        if (e.button !== 0)
            return;
        props?.onClear(value);
    };
    const renderExpanded = () => {
        return selectedTextValue.map(({ text, value }) => _jsxs("div", { className: cls.tagItem, children: [_jsx("span", { children: text }), showClear ? _jsx(Clear, { size: ".75em", onMouseDown: e => onValueClear(e, value) }) : null] }, value));
    };
    const renderCollapsed = () => {
        return _jsx("div", { className: cls.tagItem, children: _jsxs("div", { children: [selectedTextValue.length, " items selected"] }) });
    };
    return _jsxs(_Fragment, { children: [_jsxs("div", { ref: mergeRef, style: style, className: classNames(className, cls.tagHolder), children: [(!values || values.length === 0) && placeHolder ?
                        _jsx("input", { placeholder: placeHolder, readOnly: true, style: placeHolderStyle }) : null, collapse ? renderCollapsed() : renderExpanded()] }), _jsx("div", { ref: dummyRef, style: dummyElementStyle, children: _jsx("div", { style: style, className: classNames(className, cls.tagHolder), children: renderExpanded() }) })] });
};
const placeHolderStyle = { border: "none", padding: 0, lineHeight: "inherit", boxShadow: "none" };
const dummyElementStyle = { position: "fixed", top: 0, left: 0, maxWidth: "100vw", overflow: "auto", display: "none" };
